import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import API from "../../../context/API";
import type { RootState } from "../../../redux/store";
import { useActiveStoreId } from "../../Stores/hooks/useActiveStoreId";
import { THEME_FIELDS } from "../constants";
import type { ThemeColors } from "../types";

export const KIOSK_CONFIG_QUERY_KEY = ["kiosk-configuration"] as const;

// Store-scoped: the backend returns the store's own configuration row if it
// has one, else falls back to the merchant-wide configuration.
export const useKioskConfiguration = () => {
  const { role, loginData } = useSelector((state: RootState) => state.auth);
  const storeId = useActiveStoreId();

  return useQuery<ThemeColors>({
    queryKey: [...KIOSK_CONFIG_QUERY_KEY, storeId],
    queryFn: async () => {
      const params: Record<string, string> = {};
      if (role === "admin" || role === "super_admin") {
        params.merchantId = loginData?.merchantId || loginData?.id;
      }
      if (storeId) {
        params.storeId = storeId;
      }
      const res = await API.get("/kiosk-configuration", { params });
      return Object.fromEntries(
        THEME_FIELDS.map((f) => [f.key, res.data[f.key] ?? null])
      ) as ThemeColors;
    },
    staleTime: 5 * 60 * 1000,
  });
};
